import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import { Icon, Popover } from '@amzn/awsui-components-core';
import React from 'react';
import ContentInfoDetails from './ContentInfoDetails';

interface Props {
  workflow: ContentWorkflow;
}

const ContentInfoPopover = ({ workflow }: Props) => {
  const infoSvgPath = '/images/ic_information.svg';
  const contentInfoDetails = <ContentInfoDetails workflow={workflow} />;

  return (
    <Popover
      dismissAriaLabel="Close"
      fixedWidth
      size="large"
      triggerType="text"
      renderWithPortal
      content={contentInfoDetails}
    >
      <Icon url={infoSvgPath} size="normal" variant="normal" alt="Information" />
    </Popover>
  );
};

export default ContentInfoPopover;
